export const OL_MAP_ROTATION_KEY = 'ol-map-rotation';
